<!--<div class="w-100 h-100 d-flex flex-column p-4 justify-content-center align-items-center gap-3 text-center">-->
<!--  <h1 class="m-0">Submitting Order</h1>-->
  <ng-lottie width="100%" height="auto" [options]="animationOptions"></ng-lottie>
<!--</div>-->
